const LANDING_QUERY_STORAGE_KEY = "aiCompetitorsLandingQueryParams";
const CLICK_ID_KEYS = ["fbclid", "gclid", "ttclid", "msclkid"];

let landingQueryMemory = {};

const isPlainObject = (value) =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

const normalizeQueryValue = (value) => String(value ?? "").trim();

export const isAiCompetitorsTrackingQueryKey = (key = "") => {
  const normalized = String(key || "").toLowerCase();
  return normalized.startsWith("utm_") || CLICK_ID_KEYS.includes(normalized);
};

export const searchParamsToObject = (search) => {
  const params =
    search instanceof URLSearchParams
      ? search
      : new URLSearchParams(typeof search === "string" ? search : "");
  const next = {};
  params.forEach((value, key) => {
    const nextValue = normalizeQueryValue(value);
    if (!key || !nextValue) return;
    next[key] = nextValue;
  });
  return next;
};

export const pickAiCompetitorsTrackingQueryParams = (params = {}) => {
  const tracking = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (!isAiCompetitorsTrackingQueryKey(key)) return;
    const nextValue = normalizeQueryValue(value);
    if (!nextValue) return;
    tracking[key] = nextValue;
  });
  return tracking;
};

const writeLandingQueryParams = (params) => {
  landingQueryMemory = isPlainObject(params) ? params : {};
  try {
    sessionStorage.setItem(
      LANDING_QUERY_STORAGE_KEY,
      JSON.stringify(landingQueryMemory)
    );
  } catch {
    // Private mode / blocked storage: keep the in-memory snapshot.
  }
  return landingQueryMemory;
};

export const readAiCompetitorsLandingQueryParams = () => {
  try {
    const raw = sessionStorage.getItem(LANDING_QUERY_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (isPlainObject(parsed)) {
        landingQueryMemory = parsed;
        return parsed;
      }
    }
  } catch {
    // Fall back to the in-memory snapshot.
  }
  return landingQueryMemory;
};

export const captureAiCompetitorsLandingQueryParams = (search) => {
  const incoming = searchParamsToObject(search);
  const stored = readAiCompetitorsLandingQueryParams();
  const hasIncomingTracking =
    Object.keys(pickAiCompetitorsTrackingQueryParams(incoming)).length > 0;

  if (!hasIncomingTracking && Object.keys(stored).length > 0) {
    return stored;
  }
  if (Object.keys(incoming).length === 0) {
    return stored;
  }
  return writeLandingQueryParams(incoming);
};

export const appendAiCompetitorsTrackingQuery = (url, params) => {
  const tracking = pickAiCompetitorsTrackingQueryParams(
    params || readAiCompetitorsLandingQueryParams()
  );
  if (!url || Object.keys(tracking).length === 0) {
    return url;
  }
  const next = new URL(url);
  Object.entries(tracking).forEach(([key, value]) => {
    next.searchParams.set(key, value);
  });
  return next.toString();
};
